import { signupActions, signupActionTypes } from './signup.actions';
import { SignupState } from './signup.state';

const defaultState: SignupState = {
    error: 0,
    ok: false,
    result: {},
};

export type Action = signupActions;

export function SignupReducer(state = defaultState, action: any) {
    switch (action.type) {
        case signupActionTypes.DO_SIGNUP:
            return {
                ...state,
                ok: false,
                error: 0,
            };
        case signupActionTypes.DO_SIGNUP_SUCCESS:
            return {
                ...state,
                ok: true,
                error: 0,
                result: action.payload,
            };
        case signupActionTypes.DO_SIGNUP_FAIL:
            return {
                ...state,
                ok: false,
                error: action.error,
                result: action.payload,
            };
        default:
            return state;
    }
}
